import React from "react";
import styled, { keyframes } from "styled-components";
import isEqual from "react-fast-compare";
import { prop } from "styled-tools";

import BarLabels from "components/BarLabels";
import BarStackedChart from "components/BarStackedChart";

import dataAccessor from "utils/dataAccessor";

/*
 * Styles
 */

/* Chart */

const Chart = styled.div`
  > * + * {
    margin-top: 0.4rem;
  }
`;

/* ChartGroup */

const ChartGroup = styled.div`
  position: relative;
  z-index: 10;
`;

/* Container */

const enterContainer = keyframes`
  from {
    opacity: 0;
    transform: translateY(2rem);
  }
`;

const Container = styled.div`
  animation: ${enterContainer} 1200ms ${prop("theme.easings.quintOut")} 100ms
    backwards;
  padding: 1.2rem 0 6.8rem;
  position: relative;
  will-change: transform;
`;

/* Text */

const H3 = styled.h3`
  font-size: ${prop("theme.scale.down1")};
  letter-spacing: 0.125em;
  margin: 0 0 1rem;
  text-align: center;
  text-transform: uppercase;
  span {
    background: ${prop("theme.colors.grayTTTT")};
    display: inline-block;
  }
`;

/*
 * Component
 */

class BarStackedChartGroup extends React.Component {
  state = {
    clusterData: [[0, 0, 0, 0, 0]],
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props, prevProps)) {
      this.fetchData();
    }
  }

  fetchData() {
    const { data, search } = this.props;

    const filters = search.map(function (filter) {
      const values = filter[1].map((f) => parseInt(f, 10));
      return { dimension: filter[0], value: values };
    });

    let clusterData = [];

    data.forEach((datum) => {
      const accessor = new dataAccessor(datum[1]);
      const filteredDatum = accessor.get(datum[0], filters).filtered;

      let filteredPercentages = {};
      filteredDatum.weightByKey.forEach((weight) => {
        filteredPercentages[weight.key] =
          (weight.value / filteredDatum.weight) * 100;
      });
      clusterData.push(filteredPercentages);
    });

    this.setState({
      clusterData: clusterData,
    });
  }

  render() {
    const { population, years } = this.props;
    const { clusterData } = this.state;

    return (
      <Container>
        <BarLabels />
        <ChartGroup>
          <H3>
            <span>{population}</span>
          </H3>
          <Chart>
            {clusterData.map((percentages, i) => {
              return (
                <BarStackedChart
                  data={percentages}
                  size={clusterData.length > 1 ? "S" : "M"}
                  year={years[i]}
                />
              );
            })}
          </Chart>
        </ChartGroup>
      </Container>
    );
  }
}

export default BarStackedChartGroup;
